module.exports = __webpack_public_path__ + "static/headerRightBg-b347e1207f02643b0a0e2b6957c53d95.png";